import { render, staticRenderFns } from "./CommentsMediaSlider.vue?vue&type=template&id=576f56a0&scoped=true&"
import script from "./CommentsMediaSlider.vue?vue&type=script&lang=js&"
export * from "./CommentsMediaSlider.vue?vue&type=script&lang=js&"
import style0 from "./CommentsMediaSlider.vue?vue&type=style&index=0&id=576f56a0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f56a0",
  null
  
)

export default component.exports